import { initialARUniversityEntryRequest } from "../../../../../init/initRequests";
import ARUniEntryRequestForm from "./form/ARUniEntryRequestForm";
import { useEffect } from "react";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { fetchLoggedUserDetails } from "../../../../../store/redux/slice/AppData/loggedUser";

const ARUniEntryRequestNew = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchLoggedUserDetails());
  }, [dispatch]);

  return <ARUniEntryRequestForm formInitialData={initialARUniversityEntryRequest} />;
};
export default ARUniEntryRequestNew;
